import { Component, input, InputSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { PanelComponent } from '../../partial-components';
import { DataTableColumnConfigI, PanelConfigI } from '../../interfaces';

@Component({
  selector: 'app-case-table-skeleton',
  standalone: true,
  imports: [PanelComponent, TableModule, SkeletonModule, TranslatePipe],
  templateUrl: './case-table-skeleton.component.html',
  styleUrl: './case-table-skeleton.component.scss'
})
export class CaseTableSkeletonComponent {
  columns: InputSignal<{ prop: string; name: string }[]> = input.required();
  tableColumnsConfig: InputSignal<DataTableColumnConfigI[]> = input.required();

  filterPanelConfig: PanelConfigI = {
    toggleable: true,
    collapsed: true,
    expandIcon: undefined,
    collapseIcon: undefined,
    headerIcon: 'fa-solid fa-filter',
    headerLabel: 'CLAIMS.FILTERS.FILTERS_HEADER',
  };

  skeletonRows = Array.from({ length: 8 }, (_, index) => index);
}
